import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import vegetarianIcon from 'themes/[theme]/assets/images/icons/bop/vegetarian.svg';
import microwaveableIcon from 'themes/[theme]/assets/images/icons/bop/microwaveable.svg';
import organicIcon from 'themes/[theme]/assets/images/icons/bop/organic.svg';
import freezableIcon from 'themes/[theme]/assets/images/icons/bop/freezable.svg';
import frozenIcon from 'themes/[theme]/assets/images/icons/bop/frozen.svg';
import FoodProfileBadge from 'apps/foodProfile/containers/FoodProfileBadge';

export const possibleBadges = {
  vegetarian: {
    icon: vegetarianIcon,
    description: 'Suitable for vegetarians',
  },
  microwaveable: {
    icon: microwaveableIcon,
    description: 'Suitable for the microwave',
  },
  organic: {
    icon: organicIcon,
    description: 'Organic',
  },
  freezable: {
    icon: freezableIcon,
    description: 'Suitable for freezing',
  },
  frozen: {
    icon: frozenIcon,
    description: 'Frozen',
  },
};

export default class Badges extends PureComponent {
  static propTypes = {
    product: PropTypes.object,
  };

  static defaultProps = {
    product: {},
  }

  renderIcons = () => {
    const { packInfo } = this.props.product;
    const possibleIconNames = Object.keys(possibleBadges);
    const icons = Object.keys(packInfo)
      .filter(key => possibleIconNames.includes(key))
      .map(icon => (
        <img
          key={icon}
          src={possibleBadges[icon].icon}
          alt={possibleBadges[icon].description}
          title={possibleBadges[icon].description}
          className={`bop-badge bop-badge-${icon}`}
        />
      ));

    return icons;
  };

  render() {
    const {
      showFPBadge,
      product,
    } = this.props;

    return (
      <div className="bop-badges">
        {showFPBadge && <FoodProfileBadge barcode={product.gtin} />}
        {this.renderIcons()}
      </div>
    );
  }
}

